import React, { Component } from 'react';
import LoadingModal from '../common/loadingModal';
import strings from '../locales/';
import TravelAndEventsMap from './travelAndEventsMap';
import BehaviorIndicatorsBlock from '../common/behavior/behaviorIndicatorsBlock';
import CircularIndicator from '../common/indicators/circularIndicator';
import SimpleIndicator from '../common/indicators/simpleIndicator';
import Label from '../common/label';

import Message from '../common/message';

const TravelModal = props => (
  <div
    className={
      'task-modal ' + (props.showModal ? `container-modal-right` : `container-modal-right hide`)
    }
  >
    <div className="box-modal" id="modal-task">
      <a
        className={
          'close' + (props.status != 200 ? ' message' : '')
        }
        onClick={props.handleModal}
      >
        <i className="fas fa-times-circle" />
      </a>
      {props.loading ? (
        <LoadingModal height="modal-task" />
      ) : props.status == 200 &&
        props.showModal ? (
        <div className="container-detail-modal-right">
          <h3>
            {props.language.driver_behavior.buttons.travelDetail 
              + ": " + props.data.vehicleAlias}
          </h3>
          <section className="detail-inner">
            <section className="driver-behavior-grade-wrapper">
              <div className="grade-wrapper">
                <div className="modal-indicators-info right">
                  <a className="green">
                    <i className="fas fa-question-circle" />
                    <div>            
                      <p>{props.language.summary.behaviour.indicatorHelp1TravelModal}</p>
                      <p>{props.language.summary.behaviour.indicatorHelp2TravelModal}</p>
                      <p>
                        <span className="green">
                        {props.language.summary.graphTooltip.OUTOFRISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + props.graphColorRange.outOfRisk[0] + " " + props.language.summary.behaviour.to + " 100"}
                      </p>
                      <p>
                        <span className="yellow">
                        {props.language.summary.graphTooltip.MIDDLERISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + (props.graphColorRange.middleRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + props.graphColorRange.middleRisk[1]}
                      </p>
                      <p>
                        <span className="red">
                        {props.language.summary.graphTooltip.HIGHRISK + ": "}
                        </span> 
                        {props.language.summary.behaviour.between + " " + (props.graphColorRange.higherRisk[0]+1) + " " + props.language.summary.behaviour.to + " " + (props.graphColorRange.higherRisk[1])}
                      </p>
                      {props.data.severity!=null && (
                        <p>{props.language.summary.behaviour.indicatorHelp3 + " "}
                        <span className={colorSeverityItem(props.data.severity)}>{props.language.summary.graphTooltip[props.data.severity.toUpperCase()]}</span></p>
                      )}
                    </div>
                  </a>
                </div>
                <CircularIndicator
                  size={110}
                  max={100}
                  value={props.data.detail.behaviorGrade}
                  fill={false}
                  valueFormat={{ type: 'NUMBER', format: '.0f' }}
                  graphColorRange={props.graphColorRange}
                  fontSize={'24px'}
                />
                <Label label={props.language.driver_behavior.labels.behaviorGrade} />
              </div>
            </section>
            <BehaviorIndicatorsBlock
              extraId={'modal'}
              data={{
                behaviorGrade: props.data.detail.behaviorGrade,
                indicators: props.data.detail.indicators
              }}
              config={props.behaviorConfig.indicators}
              graphColorRange={props.graphColorRange}
              removeChart={true}
            />
          </section>
          <section className="driver-travel-map">
            {props.behaviorConfig 
              && props.showMap && (
              <TravelAndEventsMap
                data={props.data}
                loadingMap={props.loading}
                noLoading={true}
                config={props.behaviorConfig.events}
              />
            )}
            <section className="travel-idicators">
              <SimpleIndicator
                value={props.data.detail.travelKms}
                valueFormat={{ type: 'NUMBER', format: '.0f', sufix: ' Km' }}
              />
              <SimpleIndicator
                value={props.data.detail.travelTimeLength}
                valueFormat={{ type: 'NUMBER', format: 'hh:mm' }}
              />
            </section>
          </section>
        </div>
      ) : props.status != 200 ? (
        <div className="container-detail-modal-right message">
          <Message message={'API ERROR'} />
        </div>
      ) : (
        <div className="container-detail-modal-right" />
      )}
    </div>
  </div>
);

export default TravelModal;



// WEBPACK FOOTER //
// ./source/client/components/driver_behavior/travelModal.jsx